import * as THREE from 'three';
import {
  ThreeExt, CARD1Web
} from '../CoordUtils.js';
//桩的基本信息
export class RoadStake {
  constructor(data, coordOffset, lastStake) {
    if (data != null){
      // this.interstakesGisData = data.interstakesGisData;
      this.gisData = data.gisData;
      this.stakeval = data.stakeval;
      this.leftBaseWidth = data.leftBaseWidth;
      this.rightBaseWidth = data.rightBaseWidth;
      this.leftBaseHeight = data.leftBaseHeight;
      this.rightBaseHeight = data.rightBaseHeight;
      this.leftRootWidth = data.leftRootWidth;
      this.rightRootWidth = data.rightRootWidth;
      this.leftRootHeight = data.leftRootHeight;
      this.rightRootHeight = data.rightRootHeight;
      this.nearByFacility = data.nearByFacility;
      this.stage = data.stage;
    }
      this.CoordOffset = coordOffset;  
    
    //服务端已经计算，故不需要再计算
    if (data.a1){
      this.a1 = new THREE.Vector3(data.a1.x - this.CoordOffset.lat, data.a1.y, data.a1.z - this.CoordOffset.lon);
      this.a2 = new THREE.Vector3(data.a2.x - this.CoordOffset.lat, data.a2.y, data.a2.z - this.CoordOffset.lon);
      this.a3 = new THREE.Vector3(data.a3.x - this.CoordOffset.lat, data.a3.y, data.a3.z - this.CoordOffset.lon);
      this.b1 = new THREE.Vector3(data.b1.x - this.CoordOffset.lat, data.b1.y, data.b1.z - this.CoordOffset.lon);
      this.b2 = new THREE.Vector3(data.b2.x - this.CoordOffset.lat, data.b2.y, data.b2.z - this.CoordOffset.lon);

    }
    if (lastStake){
      this.convRoadCoord(lastStake);  
    }
    

    this.roadElementParams = new Object(); //车道，紧急停车带，中央分隔带参数
    this.roadElementParams.medialDivider = new Object();
    this.roadElementParams.medialDivider.center = this.center;
  }

  convRoadCoord(lastStake) {
    //底边中点设置为基准点
    //计算投影长度即z坐标 
    //现在只考虑直线，90度向前，这里可能是弧度或者有一定角度
    //center是坡脚中点，b1是左坡脚点，b2是右坡脚点，a1是左基缘，a2是右基缘，a3是路基中点
    this.center = new THREE.Vector3();
    this.center.z = this.gisData.longtitude - this.CoordOffset.lon;
    this.center.x = this.gisData.latitude - this.CoordOffset.lat;
    this.center.y = (this.leftRootHeight + this.rightRootHeight) / 2;
    //在服务器端没有计算坐标则客户端计算
    if (!this.a1){
        this.b1 = new THREE.Vector3();
    this.b1.y = this.leftRootHeight;

    this.b2 = new THREE.Vector3();
    this.b2.y = this.rightRootHeight;

    this.a3 = new THREE.Vector3();
    this.a3.z = this.center.z;
    this.a3.x = this.center.x;
    this.a3.y = (this.leftBaseHeight + this.rightBaseHeight) / 2;

    this.a1 = new THREE.Vector3();
    this.a1.y = this.leftBaseHeight;

    this.a2 = new THREE.Vector3();
    this.a2.y = this.rightBaseHeight;
    var factor = 1; //判断上一个桩和本桩的位置关系

    if (lastStake.center.x == this.center.x) {
      //与z轴平行
      factor = (lastStake.center.z > this.center.z) ? 1 : (-1);
      this.b1.z = this.center.z;
      this.b1.x = this.center.x + (factor * this.leftRootWidth);
      this.b2.z = this.center.z;
      this.b2.x = this.center.x - (factor * this.rightRootWidth);
      this.a3.z = this.center.z;
      this.a3.x = this.center.x;
      this.a1.z = this.a3.z;
      this.a1.x = this.a3.x + (factor * this.leftBaseWidth);
      this.a2.z = this.a3.z;
      this.a2.x = this.a3.x - (factor * this.rightBaseWidth);
    } else if (lastStake.center.z == this.center.z) {
      factor = (lastStake.center.x > this.center.x) ? 1 : (-1);     
      this.b1.z = this.center.z + (factor * this.leftRootWidth);
      this.b1.x = this.center.x;
      this.b2.z = this.center.z - (factor* this.rightRootWidth);
      this.b2.x = this.center.x;
      this.a3.z = this.center.z;
      this.a3.x = this.center.x;
      this.a1.z = this.a3.z + (factor*this.leftBaseWidth);
      this.a1.x = this.a3.x;
      this.a2.z = this.a3.z - (factor*this.rightBaseWidth);
      this.a2.x = this.a3.x;
    } else {
      //计算横断面的斜率,与两个终点连线所确定的直线垂直，故为-1/k
      var tgAlpha = -(lastStake.center.x - this.center.x) / (lastStake.center.z - this.center.z);
      var cosAlpha = Math.sqrt(1 / (1 + tgAlpha * tgAlpha));
      if (tgAlpha < 0) {
        //钝角，cos<0
        cosAlpha = cosAlpha * (-1);
      }
      var sinAlpha = Math.sqrt(1 - cosAlpha * cosAlpha);

      var vecPt1 = new THREE.Vector2();
      //x轴一定是一个加一个减，由此可以计算出y,把两个解求出来
      //坡脚
      var x1 = this.center.x + Math.abs(this.leftRootWidth * cosAlpha);
      var x2 = this.center.x - Math.abs(this.leftRootWidth * cosAlpha)
      var y1 = tgAlpha * (x1 - this.center.x) + this.center.z;
      var y2 = tgAlpha * (x2 - this.center.x) + this.center.z;
      var ptRoot1 = new THREE.Vector2(x1, y1);
      var ptRoot2 = new THREE.Vector2(x2, y2);
      //路基
      var xB1 = this.a3.x + Math.abs(this.leftBaseWidth * cosAlpha);
      var xB2 = this.a3.x - Math.abs(this.leftBaseWidth * cosAlpha)
      var yB1 = tgAlpha * (xB1 - this.a3.x) + this.a3.z;
      var yB2 = tgAlpha * (xB2 - this.a3.x) + this.a3.z;
      var ptBase1 = new THREE.Vector2(xB1, yB1);
      var ptBase2 = new THREE.Vector2(xB2, yB2);

      //上一个桩号和这一个桩的b1的朝向应该是相同的，即减掉中心的向量方向，因此判断其夹角小于90度为b1,另一个解为b2
      //判断向量点集的正负即是夹角大小
      ////从起点往终点望去，a1为右，a2为左
      this.b1.z = ptRoot1.y;
      this.b1.x = ptRoot1.x;
      this.b2.z = ptRoot2.y;
      this.b2.x = ptRoot2.x;
      this.a1.z = ptBase1.y;
      this.a1.x = ptBase1.x;
      this.a2.z = ptBase2.y;
      this.a2.x = ptBase2.x;
      
      //第一个桩的初始化就不需要判断两解分别赋予b1还是b2,
      //然而第一个桩的初始化是需要判定其b1b2的方向的
      //这里判断后面的桩，每一个桩的b1都和上一个桩的b1同向
      if (lastStake.stakeval < this.stakeval) {
        var ptSubVec = new THREE.Vector2();
        ptSubVec.copy(ptRoot1);
        ptSubVec.sub(new THREE.Vector2(this.center.x, this.center.z));
        var ptLastSubVec = new THREE.Vector2(lastStake.b1.x, lastStake.b1.z);
        ptLastSubVec.sub(new THREE.Vector2(lastStake.center.x, lastStake.center.z));

        if (ptSubVec.dot(ptLastSubVec) < 0) {
          this.b2.z = ptRoot1.y;
          this.b2.x = ptRoot1.x;
          this.b1.z = ptRoot2.y;
          this.b1.x = ptRoot2.x;
          this.a2.z = ptBase1.y;
          this.a2.x = ptBase1.x;
          this.a1.z = ptBase2.y;
          this.a1.x = ptBase2.x;
        }
      }
      else{
          this.helper = new CARD1Web.CoordUtils.Helper();
        if (this.helper.leftOfLine(new THREE.Vector2(this.center.x, this.center.z), 
          new THREE.Vector2(lastStake.center.x, lastStake.center.z), 
          new THREE.Vector2(ptRoot1.x, ptRoot1.y)
          )){
            //第一个桩的b1 b2判定,从第二桩往起始桩望，在起始桩左边，则反过来望在右边
            this.b2.z = ptRoot1.y;
            this.b2.x = ptRoot1.x;
            this.b1.z = ptRoot2.y;
            this.b1.x = ptRoot2.x;
            this.a2.z = ptBase1.y;
            this.a2.x = ptBase1.x;
            this.a1.z = ptBase2.y;
            this.a1.x = ptBase2.x;
        }
      }

    }
    }

    this.calcBasePt();
  }

  calcBasePt(){
    this.baseCenter = new THREE.Vector3();
    this.baseCenter.copy(this.a3);
    //计算右边路中间的坐标，用于导航
    this.navPt = new THREE.Vector3();
    this.navPt.copy(this.a3);
    this.navPt.lerp(this.a2, 0.5);
  }


}


// WEBPACK FOOTER //
// ./src/plugins/drawings3D/models/RoadStake.js